/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type Image, ImageSchema } from './image'

/* TypeScript */
export type EmbeddedYoutubeVideoApiProps = {
  technicalName?: Maybe<string>
  youtubeId: string
  title?: Maybe<string>
  subtitle?: Maybe<string>
  size?: Maybe<'small' | 'medium'>
  image?: Maybe<Image>
}

export type CTAVideo = {
  label: string
  title?: Maybe<string>
  id: string
}

export type VideoAssetFile = {
  contentType: string
  fileName: string
  url: string
  details: { size: number }
}

export type VideoAsset = {
  title: string
  description: string
  file: VideoAssetFile
}

export type Video = {
  id: string
  video: VideoAsset
  image: Image
}

/* Schemas */
export const YoutubeVideoSchema = z.object({
  technicalName: z.nullish(z.string()),
  youtubeId: z.string(),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  size: z.nullish(z.enum(['small', 'medium'])),
  image: z.nullish(ImageSchema),
})

export const CTAVideoSchema = z.object({
  label: z.string(),
  title: z.nullish(z.string()),
  id: z.string(),
})

export const VideoAssetFileSchema = z.object({
  contentType: z.string(),
  fileName: z.string(),
  url: z.string(),
  details: z.object({
    size: z.number(),
  }),
})

export const VideoAssetSchema = z.object({
  title: z.string(),
  description: z.string(),
  file: VideoAssetFileSchema,
})

export const VideoSchema = z.object({
  id: z.string(),
  video: VideoAssetSchema,
  image: ImageSchema,
})

/* Schemas validation */
type TestYoutubeVideo = ExpectTrue<
  Equal<EmbeddedYoutubeVideoApiProps, z.infer<typeof YoutubeVideoSchema>>
>
type TestCTAVideo = ExpectTrue<Equal<CTAVideo, z.infer<typeof CTAVideoSchema>>>
type TestVideo = ExpectTrue<Equal<Video, z.infer<typeof VideoSchema>>>
